import { createAction } from '@reduxjs/toolkit';
import { SET_USER_INFO, SET_TOKEN, LOGOUT } from './types';
import { UserInfo } from '../models';

export const setToken = createAction<string>(SET_TOKEN);
export const setUserInfo = createAction<UserInfo>(SET_USER_INFO);
export const logout = createAction(LOGOUT);
